import { defineFeatureRoutes } from '@/app/router/registry'
import { messages } from './i18n'

/** Exported so the channel card (features/channel, a different package) can link here without hardcoding the name - same reasoning as features/stats/routes.ts's CHANNEL_STATS_ROUTE. */
export const CHANNEL_AUDIO_ROUTE = 'channel-audio'

export default defineFeatureRoutes([
  {
    path: '/channels/:id/audio',
    name: CHANNEL_AUDIO_ROUTE,
    component: () => import('./AudioView.vue'),
    props: true,
    // No nav entry: reached from the channel card, like /channels/:id/stats.
    meta: { title: messages.lazy('title') },
  },
])
